/**
 * API service for the Site Layout tab.
 *
 * TODO: Full implementation
 */
import { apiRequest } from 'src/services/apiMiddleware';
import { API_GATEWAY_PROCESS_NAME } from 'src/utils/constants';
import {
  GetSiteLayoutConfigResponse,
  GetAvailableProcessPathsResponse,
  SaveSiteLayoutConfigRequest,
  SaveSiteLayoutConfigResponse,
} from './types';

/**
 * Fetch site layout configuration for a warehouse.
 */
export const getSiteLayoutConfig = async (
  warehouseId: string
): Promise<GetSiteLayoutConfigResponse> => {
  const response = await apiRequest({
    resourcePath: '/getSiteLayoutConfig',
    httpMethod: 'post',
    processName: API_GATEWAY_PROCESS_NAME,
    requestBody: { warehouseId },
  });

  if (response.status && response.status >= 400) {
    throw new Error(response.errorResponse || 'Failed to fetch site layout config');
  }

  return response.data;
};

/**
 * Fetch available process paths for a warehouse.
 */
export const getAvailableProcessPaths = async (
  warehouseId: string
): Promise<GetAvailableProcessPathsResponse> => {
  const response = await apiRequest({
    resourcePath: '/getAvailableProcessPaths',
    httpMethod: 'post',
    processName: API_GATEWAY_PROCESS_NAME,
    requestBody: { warehouseId },
  });

  if (response.status && response.status >= 400) {
    throw new Error(response.errorResponse || 'Failed to fetch available process paths');
  }

  return response.data;
};

/**
 * Save site layout configuration for a warehouse.
 */
export const saveSiteLayoutConfig = async (
  request: SaveSiteLayoutConfigRequest
): Promise<SaveSiteLayoutConfigResponse> => {
  const response = await apiRequest({
    resourcePath: '/saveSiteLayoutConfig',
    httpMethod: 'post',
    processName: API_GATEWAY_PROCESS_NAME,
    requestBody: request,
  });

  if (response.status && response.status >= 400) {
    throw new Error(response.errorResponse || 'Failed to save site layout config');
  }

  return response.data;
};
